import styled from "styled-components";

const Dropdown = styled.div`
  display: flex;
  flex-direction: column;
  width: 22.5em;
  padding: 0.25em;
  background-color: white;
  margin-top: 0.25em;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.3);
`;

export default Dropdown;
